import img_document from "assets/img/service_digital_documents.svg";

import { Link } from "@mui/material";
import { MenuItemButton } from "components/menu/MenuItemButton";

export const MenuItemButtonGoToDocument = ({
  signLink,
  onClickCallback,
}: {
  signLink: string;
  onClickCallback: () => void;
}) => {
  return (
    <Link href={signLink} target="_blank" color={"inherit"}>
      <MenuItemButton
        onClick={onClickCallback}
        iconSrc={img_document}
        title={"Документ"}
      />
    </Link>
  );
};
